import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JobRoutingModule } from './job-routing.module';
import { SharedModule } from '../shared/shared.module';
import { BaiduMapModule } from 'angular2-baidu-map';

//组件
import { CategoryOptionModule } from './category-option/category-option.module';
import { JobLongModule } from './job-long/job-long.module';
import { LatestInformationModule } from './latest-information/latest-information.module';
import { JobCompanySmallInforModule } from './job-company-small-infor/job-company-small-infor.module';


import { HomeComponent } from './home/home.component';
import { DetailComponent } from './detail/detail.component';
import { UserFixTop } from './detail/user-fix-top.component';
import { CompanyComponent } from './company/company.component';
import { JobComponent } from './job.component';
//服务组件

// 岗位首页服务
import { HomeService } from './home/home.service';
import { DetailService } from './detail/detail.service';
import { CompanyService } from './company/company.service';
// import {CoreModule} from '../core/core.module';
import { PipeModule } from '../core/pipe/pipe.module';

@NgModule({
  imports: [
    CommonModule, PipeModule, SharedModule, BaiduMapModule, CategoryOptionModule, JobLongModule, LatestInformationModule,
    JobCompanySmallInforModule,
    JobRoutingModule,
    // CoreModule
  ],
  declarations: [HomeComponent, DetailComponent, CompanyComponent, JobComponent, UserFixTop],
  providers: [HomeService, DetailService, CompanyService],
})
export class JobModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/job.module.ts